import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';

export const useListAvatarProjects = () => {
  const { callEndpoint } = useAPIContext();
  const listAvatarProjects = React.useCallback(async () => {
    try {
      const res = await callEndpoint<AvatarsAPI, 'list-avatar-projects'>('avatars', `/projects`, 'GET');
      if (!res) throw new Error('Respuesta del servidor inesperada');
      return res;
    } catch (error: any) {
      console.error('Error al listar los proyectos:', error);
      return null;
    }
  }, [callEndpoint]);

  return { listAvatarProjects };
};
